// extracted by mini-css-extract-plugin
export var section = "columns-module--section--1DoA0";
export var label = "columns-module--label--1vW-1";
export var columns = "columns-module--columns--baBqm";
export var column = "columns-module--column--2wdOs";
export var image = "columns-module--image--1gncV";
export var heading = "columns-module--heading--3mEwr";
export var text = "columns-module--text--2cFqf";